import {store} from "../stores/mainStore";
import {isValidHand} from "./helpers";

export var scoreCardElements = [];

export const getDiceReduce = (diceInHand) => {
	return (diceInHand > 5 ? 0.8 : 1.0);
}
export const showScorecardHandTray = (count, leftEdge, y, showQmarks) => {
	const m = window.manager;
	var diceInHand = count > 0 ? count : 5;
	let diceReduce = getDiceReduce(diceInHand);
	if(diceInHand > 6)
		diceInHand = 5;
	var diceOffset = (33 * m.scaleFactor) * diceReduce;
	for(let d=0;d < diceInHand;d++) {
		var tinyX = (leftEdge)+d*diceOffset;
		var tinyY = y+3*m.scaleFactor;
		var useQuestion = false;// (/*(store.tutorialMode || store.activeMatch.roundCount === 1) && */ leftEdge > 0);
		useQuestion |= showQmarks;
		var tinyDice1 = m.scene.add.sprite(tinyX, tinyY, 'common', useQuestion ? 'dice_Q_40.png' : 'lil_brown_box.png');
		if(m.scoreCardContainer)
			m.scoreCardContainer.add(tinyDice1);
		var scale = 0.625 * m.scaleFactor;
		if (useQuestion) scale *= ((54 / 40) * 40) / 64;
		else {
			tinyDice1.setAlpha(0.4);
			scale *= 0.975;
		}
		scale *= diceReduce;
		tinyDice1.setScale(scale);
		m.scoreCardElements.push(tinyDice1);
	}
}

export const DICE_TYPE = {
	TRAY: 'tray',
	QUESTION: 'questions',
	FROWN: 'frown',
	BONUS: 'bonusOutline',
	STROKE: 'outline',
	NONE: 'none'
}
export const scorecardDiceRow = (type, x, y, hand = null, _size = 64, centered = true) => {
	const m = window.manager;
	const isTray = type === DICE_TYPE.TRAY;
	const isQuestion = type === DICE_TYPE.QUESTION;
	
	const isHand = hand !== null;
	const isFrown = isHand && !isValidHand(hand);
	const isStroke = !isFrown && (type === DICE_TYPE.BONUS || type === DICE_TYPE.STROKE);
	const handName = isHand ? m.hands[hand.lastCombination || hand.bestHandTarget] : '';
	const allRed = handName === 'all-red';
	const allBlack = handName === 'all-black';
	const isTrim = false; //isHand && hand.match.length > 6;
	const defCount = m.dicePerHandType[m.handBannerHandNames.indexOf(handName)];
	const count = (isHand && !isFrown && !allBlack && !allRed) 
		? Math.min(hand.match.length, 6) : (defCount || 5)
	//console.log('7833 \t h =', isHand, 'tr =', isTray, 'fr =', !isFrown, 'ab =', !allBlack, 'ar =', !allRed, 'NAME =', handName, '\n\t\t lc =', hand && hand.lastCombination, 'num =', hand && m.dicePerHandType[hand.lastCombination], '\n\t\t ind =', m.handBannerHandNames.indexOf(handName), 'num =',  defCount, '\n\t\t m =', hand && hand.match.length, 'HAND =', hand)
	const size = _size * 5/Math.max(5, count);

	const diceCont = m.scene.add.container(x, y);
	for(let i = 0; i < count; i++) {
		const isDots = isTrim && i === 5;
		const assetName = (isHand && !isTray && !isDots && !isFrown && !allBlack && !allRed) 
			//? store.custom.dice + '_dice2D_sheet_64' 
			? 'dice2D_sheet_64' 
			: isHand && !isTray && !isDots && !isFrown && (allBlack || allRed) 
				//? store.custom.dice + '_suits' : 'common';
				? 'suits' : 'common';
		/* const diceInd = isHand && !isFrown 
			? (isNaN(hand.match[i]) ? hand.match[i].dice : hand.match[i]) 
			: 0;
		const faceInd = isHand && !isFrown && (isNaN(hand.match[i]) ? hand.match[i].face : hand.dice[diceInd].showing) */
		const frameName = isTray ? 'lil_brown_box.png' :
			isQuestion ? 'dice_Q_40.png' :
			isFrown ? 'dice_frown_40.png' :
			isDots ? 'scorecard_3Dots.png' :
			allRed ? 2 + (i % 2) :
			allBlack ? i % 2 :
			//6* diceInd + faceInd;
			hand.match[i].currentFace;

		if(isStroke && !isDots) {
			const outline = m.scene.add.sprite(size*i, 0, 'common', type === DICE_TYPE.BONUS ? 'PinkBoxSprite.png' : 'BlueBoxSprite.png');
			outline.setScale(size / outline.width);
			diceCont.add(outline);
		}
		if(!isDots) {
			const dice = m.scene.add.sprite(size*i, 0, assetName, frameName);
			dice.setScale(size / dice.width *(isStroke ? 0.9 : 1));
			m.diceInstances.add(dice);
			diceCont.add(dice);
		}
	}
	if(centered) {
		const dx2 = - size*(count-1) / 2;
		diceCont.list.forEach(ch => ch.x += dx2);
	}
	
	if(m.scoreCardContainer)
		m.scoreCardContainer.add(diceCont)
	return diceCont;
}

export const createHandName = config => {
	const {nameCont, handName, x, size, maxWidth, inScorecard} = config;
	const m = window.manager;
	const padding = 5;
	nameCont.removeAll(true);
	
	const textParts = store.getHandName(handName).split('*')
	const totalWidth = textParts.reduce((tot, str) => {
		let res;
		if(str.startsWith('suit')) {
			//res = m.scene.add.sprite(tot, 0.05*size, store.custom.dice + '_suits', str.charAt(str.length-1))
			res = m.scene.add.sprite(tot, 0.05*size, 'suits', str.charAt(str.length-1))
				.setOrigin(0, 0.5).setDisplaySize(54/57 *size , size); // 54x57 = size of suit pic
			m.diceInstances.add(res)
		} else {
			res = m.scene.add.text(tot, 0, str,
			{ 	font: '800 '+size+'px ' + m.ui.dodFontFamily,
				fill: '#ffffff', stroke: '#6e2411', strokeThickness: 2,
				shadow: { offsetX: 0, offsetY: 3, color: '#7d1b0080', blur: 0, stroke: false, fill: true }
			}).setOrigin(0, 0.5);
		}
		nameCont.add(res);
		return tot + res.displayWidth - 5;
	}, 0);
	const scale = Math.min(1, maxWidth / totalWidth);
	nameCont.setScale(scale);
	if(inScorecard) {
		const h = (size + 2*padding) / scale;
		var graphics = m.scene.add.graphics();
		graphics.fillStyle(0xa26325, 0.5);
		graphics.fillRoundedRect(-2*padding, -h/2, totalWidth + 4*padding, h, padding);
		nameCont.addAt(graphics, 0);
	} else {
		nameCont.setX(x - scale*totalWidth/2)
	}
	nameCont.config = config;
}
export const addHandName = (x, y, hand, size, maxWidth, inScorecard = false) => {
	const m = window.manager;
	const handName = hand.lastCombination === 0 ? '' : hand.lastCombination ? m.hands[hand.lastCombination] : hand;
	const nameCont = m.scene.add.container(x, y);

	createHandName({handName, x, nameCont, size, maxWidth, inScorecard})
	m.handNameInstances.add(nameCont);

	if(inScorecard && m.scoreCardContainer)
		m.scoreCardContainer.add(nameCont)
	return nameCont
}